module.exports = __webpack_public_path__ + "img/b0.a429aa54.png";